import { render } from "./NotificationSurveyAllResults.vue?vue&type=template&id=717af17a&scoped=true&ts=true"
import script from "./NotificationSurveyAllResults.vue?vue&type=script&lang=ts"
export * from "./NotificationSurveyAllResults.vue?vue&type=script&lang=ts"

import "./NotificationSurveyAllResults.vue?vue&type=style&index=0&id=717af17a&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717af17a"]])

export default __exports__